import classnames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IConnectionDetailsDTO } from '../../../../../api/connections.dao';
import { DELETE_TEXT } from '../../../../../constants/common-labels.constants';

export interface IProps {
    className?: string;
    classNameWrapper?: string;
    connection: IConnectionDetailsDTO;
    setDeletePopoverConnection: (connection: IConnectionDetailsDTO | null) => void;
    isPopoverOpen?: boolean;
    setIsPopoverOpen?: (state: boolean) => void;
    shouldDisableDeleteButton: boolean;
}

const ConnectionDeleteButton = (props: IProps) => {

    const onClickHandler = () => {
        if (props.isPopoverOpen) props.setIsPopoverOpen(false);
        props.setDeletePopoverConnection(props.connection);
    };

    return (
        <div
            className={classnames(props.classNameWrapper, {
                'button-disabled': props.shouldDisableDeleteButton
            })}
            onClick={props.shouldDisableDeleteButton ? undefined : () => onClickHandler()}
            data-test-id='connection-delete-button'
        >
            <label
                className={classnames(props.className)}
            >
                <FormattedMessage {...DELETE_TEXT} />
            </label>
        </div>
    );
};

export { ConnectionDeleteButton };
